import React, { useContext } from "react";

export const ExperimentContext = React.createContext<Record<string, boolean | string>>({});

export const useExperimentContext = (): Record<string, boolean | string> => {
  const experiments = useContext(ExperimentContext);
  if (experiments === null) {
    throw new Error("You must wrap your components in a FeatureProvider.");
  }
  return experiments;
};

export const useExperimentFlag = (experimentName: string): boolean | string => {
  const experiments = useExperimentContext();
  return experiments[experimentName];
};
